'use strict';
import Helpers from '../_helpers';
/**
 * Click event class
 *
 */
export default class Click {
    /**
     * Constructor
     *
     * @param Config_Interface
     */
    constructor(config) {
        /**
         * Helper
         *
         * @type Helpers
         */
        this.helpers = new Helpers;
        this._config = config;
    }
    /**
     * Init clicks
     *
     * @param   string          css_selector
     * @param   object          dataLayer
     * @param   Array<string>   ignore
     */
    any(css_selector, dataLayer, ignore) {
        let selector = this.build_selector_query(css_selector, ignore);
        if (this._config.is_testing) {
            console.table({
                'Click Event': dataLayer['event'],
                'CSS Selector': selector
            });
        }
        document.querySelectorAll(selector).forEach((link) => {
            link.addEventListener('click', (e) => {
                const target = link;
                // Build custom model object for link event
                let custom_model = {
                    component: '',
                    event: '',
                    id: target.id,
                    text: target.innerText,
                    url: target.href,
                    data: target.dataset,
                };
                if (this._config.component_class && this._config.component_class != '') {
                    let c = link.closest('.' + this._config.component_class);
                    if (c && c.id) {
                        custom_model.component = c.id;
                    }
                }
                // Check and push dataLayer object reference against custom model
                window.dataLayer.push(this.helpers.process_datalayer(dataLayer, { link: custom_model }));
                if (this._config.is_testing) {
                    e.preventDefault();
                }
            });
        });
    }
    /**
     * Build CSS selector query for querySelectorAll
     *
     * If CSS selector is provided, use that
     * Otherwise build ignore_classnames query
     * Default to all <a> anchor links
     *
     * @param string          css_selector
     * @param Array<string>   ignore_classnames
     */
    build_selector_query(css_selector, ignore_classnames) {
        let query = 'a';
        if (css_selector !== undefined && css_selector !== '') {
            query = css_selector;
        }
        // Set ignore query
        if (ignore_classnames !== undefined) {
            query += ':not(' + ignore_classnames.map((e) => { return e; }).join(',') + ')';
        }
        return query;
    }
}
